export default __webpack_public_path__ + "static/3fb920d552740b3bc9b2fa3b6d58c100-fcb3e06adf05fc0844e7ea36b38e74ef.png";